<template>
  <div class="root">
    <button class="prompt" @click="openModal">
      <span>Help us improve</span>
      <font-awesome-icon :icon="['fas', 'comment-lines']" class="icon alt" />
    </button>
  </div>
</template>

<script>
import { toB64 } from '@/helpers';
import FeedbackModal from './FeedbackModal.vue';

const forms = {
  collegeAdminDashboard: '665c91b9b6bb52255f251d312453f67d'
};

const page = (strings) =>
  [
    '<!doctype html><html><body style="background-color: #224b73;">',
    ...strings,
    '</body></html>'
  ].join('');

const pages = {
  test: page`<h1 style="color: #fff;">Test!</h1>`,
  error: page`<h1 style="color: #f00;">You must specify a <code>form</code> or <code>formId</code> property!</h1>`
};

export default {
  name: 'Feedback',

  props: {
    form: {
      type: String,
      default: () => null
    },
    formId: {
      type: String,
      default: () => null
    },
    test: {
      type: Boolean,
      default: () => false
    }
  },

  data() {
    let url;

    if (this.test) {
      url = `data:text/html;base64,${toB64(pages.test)}`;
    } else if (this.formId) {
      url = `https://forms.monday.com/forms/embed/${this.formId}?r=use1`;
    } else if (this.form) {
      url = `https://forms.monday.com/forms/embed/${forms[this.form]}?r=use1`;
    } else {
      url = `data:text/html;base64,${toB64(pages.error)}`;
    }

    return {
      formUrl: url,
      iframeLoaded: false
    };
  },

  methods: {
    openModal() {
      this.$modal.show(FeedbackModal, {
        classes: ['feedback'],
        props: {
          loading: this.iframeLoaded,
          formUrl: this.formUrl,
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@media print {
  .root {
    display: none;
  }
}

.prompt {
  position: fixed;
  right: 20px;
  bottom: 20px;
  min-width: 56px;
  height: 56px;
  border-radius: 28px;
  background: #1c3a59;
  padding: 10px;
  color: #fff;
  border: none;
  box-shadow: 0px 6px 4px -4px rgb(0 0 0 / 40%);
  z-index: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  max-width: 56px;
  outline-offset: 4px;

  svg {
    font-size: 28px;
  }

  span {
    word-wrap: none;
    white-space: nowrap;
    overflow: hidden;
    max-width: 0;
    opacity: 0;
    transition: all 0.8s ease;
  }

  &:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    max-width: 200px;

    span {
      opacity: 1;
      max-width: 120px;
      margin-right: 10px;
    }
  }

  &:active {
    background: #fff;
  }

  &:focus {
    outline: 2px solid #1c3a59;
  }
}
</style>
